/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Eval_Desc4Inputs */

const en_svc_rag_knowledge_assistants_eval_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Groundedness and relevance scored on every deploy, drift caught early.`)
};

const ar_svc_rag_knowledge_assistants_eval_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الترسيخ والملاءمة يقيمان عند كل نشر، والانحراف يكشف مبكرا.`)
};

const bn_svc_rag_knowledge_assistants_eval_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রতিটি ডিপ্লয়ে ভিত্তি আর প্রাসঙ্গিকতা স্কোর হয়, বিচ্যুতি আগেই ধরা পড়ে।`)
};

const de_svc_rag_knowledge_assistants_eval_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fundiertheit und Relevanz werden bei jedem Deploy bewertet, Drift früh erkannt.`)
};

const es_svc_rag_knowledge_assistants_eval_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fundamentación y relevancia puntuadas en cada despliegue, desviaciones detectadas pronto.`)
};

const fr_svc_rag_knowledge_assistants_eval_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancrage et pertinence notés à chaque déploiement, dérive détectée tôt.`)
};

const pt_svc_rag_knowledge_assistants_eval_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fundamentação e relevância pontuadas em cada lançamento, desvios detetados cedo.`)
};

const zh_svc_rag_knowledge_assistants_eval_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每次发布都给有据性和相关性打分，早发现漂移。`)
};

const tr_svc_rag_knowledge_assistants_eval_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dayanak ve alaka her yayında puanlanır, sapma erken yakalanır.`)
};

const ru_svc_rag_knowledge_assistants_eval_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обоснованность и релевантность оцениваются при каждом деплое, дрейф ловится рано.`)
};

const pl_svc_rag_knowledge_assistants_eval_desc4 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Eval_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ugruntowanie i trafność punktowane przy każdym wdrożeniu, dryf łapany wcześnie.`)
};

/**
* | output |
* | --- |
* | "Groundedness and relevance scored on every deploy, drift caught early." |
*
* @param {Svc_Rag_Knowledge_Assistants_Eval_Desc4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_eval_desc4 = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Eval_Desc4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Eval_Desc4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_eval_desc4(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_eval_desc4(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_eval_desc4(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_eval_desc4(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_eval_desc4(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_eval_desc4(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_eval_desc4(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_eval_desc4(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_eval_desc4(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_eval_desc4(inputs)
	return en_svc_rag_knowledge_assistants_eval_desc4(inputs)
});
export { svc_rag_knowledge_assistants_eval_desc4 as "svc_rag-knowledge-assistants_EVAL_desc" }